import { useCallback } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getOpenDockWarehouseFormFields } from '../../use-cases/getOpenDockWarehouseFormFields'

export function useGetOpenDockWarehouseFormFields() {
  const { call, result, status, error } = useAsync(getOpenDockWarehouseFormFields)
  const abortController = useAbortController()

  const fetchOpenDockWarehouseFormFields = useCallback(
    (shipmentUUID: string, stopIndex: number, loadTypeId: string) => {
      return call({
        shipmentUUID,
        stopIndex,
        params: { loadTypeId },
        config: abortController,
      })
    },
    [call, abortController]
  )

  return {
    warehouseFormFields: result,
    status,
    error,
    fetchOpenDockWarehouseFormFields,
  }
}
